// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var emphasis = "StreamPlayerWithLoader-module--emphasis--d89b2";
export var errorIcon = "StreamPlayerWithLoader-module--errorIcon--56425";
export var errorMessage = "StreamPlayerWithLoader-module--errorMessage--b0c3d";
export var green = "#57d33b";
export var greenLink = "StreamPlayerWithLoader-module--green-link--b906b";
export var grey = "var(--tone-mid)";
export var loading = "StreamPlayerWithLoader-module--loading--4bb80";
export var notchGap = "32px";
export var orange = "#f8662b";
export var red = "#ff2741";
export var stream = "StreamPlayerWithLoader-module--stream--0bfdc";
export var streamError = "StreamPlayerWithLoader-module--streamError--55234";
export var streamErrorButton = "StreamPlayerWithLoader-module--streamErrorButton--caf11";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";